import '@/locales';
import { router } from '@/router';
import '@/styles/index.css';
import { patchDabeeoMapsImageLoaderUrl } from '@/utils/dabeeomaps/patchImageLoaderUrl';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 60,
            gcTime: 1000 * 60 * 60 * 2,
        },
        mutations: {
            retry: 0,
        },
    },
});

patchDabeeoMapsImageLoaderUrl();

createRoot(document.getElementById('root')!).render(
    // <StrictMode>
    <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
    // </StrictMode>
);
